import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setBookingFormValue } from "shared/data/actions/bookingForm";
import { useResultPromoCodes } from "shared/hooks/bookingForm/resultPromoCodes";

import FormattedMessage from "@components/UI/FormattedMessage";
import { LegacyModalAlert } from "@components/UI/useModalAlert";

const PROMO_CODE_WARNING_SUCCESS = "50-32";

interface ResultPromoCodesProps {
  getPriceWithPromoCode: (string) => void;
  destination: string;
}

const LOADING_PROMO_CODE_WARNING = "LOADING";

export default function ResultPromoCodes({
  getPriceWithPromoCode,
  destination,
}: ResultPromoCodesProps) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { refs } = router.query;

  const {
    promoCodesEnabled,
    promoCodeWarning,
    promoCodePopupErrorMessage,
    setPromoCodePopupErrorMessage,
    onSubmit,
    isMultiCity,
  } = useResultPromoCodes({
    getPriceWithPromoCode,
    destination,
    dispatch,
    refs,
    alternativeCurrency: router?.query?.currency,
  });

  useEffect(() => {
    dispatch(setBookingFormValue("promoCode", null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!promoCodesEnabled || isMultiCity) {
    return null;
  }

  const isLoadingPromoCode =
    promoCodeWarning?.Code === LOADING_PROMO_CODE_WARNING;

  return (
    <div id="promo-codes-container">
      <h3 className="h3 result-h3">
        <FormattedMessage id="ResultPromoCodes.title" />
      </h3>
      <div className="result-summary-box">
        <span className="result-promocodes-description">
          <FormattedMessage id="ResultPromoCodes.description" />
        </span>
        <form action="" onSubmit={onSubmit}>
          <div className="result-promocodes-form">
            <div className="result-promocodes-form-code">
              <input
                disabled={isLoadingPromoCode}
                className="form-text-input-field result-promocodes-form-code-field"
                id={`result-promocodes-form-code-field_${destination}`}
              />
            </div>
            <div className="result-promocodes-form-button">
              <button
                disabled={isLoadingPromoCode}
                className="result-promocodes-form-button-button button-secondary-color"
              >
                {isLoadingPromoCode ? (
                  <div className="result-promocodes-form-button-loader" />
                ) : (
                  <FormattedMessage id="ResultPromoCodes.apply" />
                )}
              </button>
            </div>
          </div>
        </form>
        {promoCodeWarning &&
          promoCodeWarning?.Code !== LOADING_PROMO_CODE_WARNING && (
            <div
              className={`result-promocodes-apply result-promocodes-apply-${
                promoCodeWarning.Code === PROMO_CODE_WARNING_SUCCESS
                  ? "success"
                  : "error"
              }`}
            >
              {promoCodeWarning.$t}
            </div>
          )}
      </div>
      <LegacyModalAlert
        show={!!promoCodePopupErrorMessage}
        onClose={() => setPromoCodePopupErrorMessage(null)}
        message={promoCodePopupErrorMessage}
        hideHeader
      />
    </div>
  );
}
